/**
 * Gestion du paramètrage utilisateur
 */

$(document).ready(function () {

    // SPECIFIQUE TABLES
    function callbackSettings(table) {
        if(table == 'table-candidats-locataires') {
            $('.prioritySelect select').hide();
        }
        var $table = $('#'+table);
        $table.bootstrapTable({
            sortReset: true
        });
    }

    function callbackPropSettings(prop) {

    }



    // MODAL DEFINITION DES COLONNES
    // Affichage du modal
    $(".user-settings .btn-define-columns").on('click', function (e) {
        e.stopImmediatePropagation();
        if ($('#modal-settings-columns').data('conuuid')) {
            $('#modal-settings-columns').modal();
        } else {
            alert('Impossible de mettre à jour les paramètres utilisateur');
        }

    });

    // Action définition des colonnes
    $('#modal-settings-columns .btn-validate-settings-columns').on('click', function (e) {

        var props = [];
        var $btn = $(e.currentTarget);
        var $table = $('#'+$btn.data('table'));
        var callback = $('#'+$btn.data('callback'));
        var $toolbar = $('#toolbar-'+$btn.data('table'));
        var prop =null;
        $.each($('#modal-settings-columns .form-check-input'), function (key, input) {
            prop = {};
            prop['name'] = $(input).data('key');
            prop['value'] = ($(input).is(':checked') ? 'on' : 'off')
            props.push(prop);
        });
        var url = '/candidats/ajaxUpsertSettings';
        var csrf = Util.getCsrf();
        var data = {
            namespace: 'tables/candidats_locataires',
            type: 'table_columns',
            conuuid: $('#modal-settings-columns').data('conuuid'),
            data: props
        };
        data[csrf.name] = csrf.value;
        $.ajax({
            type: 'POST',
            url: PROFIL + url,
            data: data,
            dataType: 'json'
        }).done(function (response) {
            $('#modal-settings-columns').modal('hide');

            $.each(props, function (key, prop) {
                var $filtre = $toolbar.find('.form-group.'+prop['name']);
                if($filtre) {
                    if(prop.value == 'on') {
                        $filtre.show();
                    } else {
                        $filtre.hide();
                    }
                }

                $table.bootstrapTable(((prop.value == 'on')?'showColumn':'hideColumn'), prop.name);

                // Actions spécifiques
                callbackPropSettings(prop);
            });
            callbackSettings($btn.data('table'));
        });
    });
});
